<template>
  <div class="tw-bg-gray-100 tw-p-5">
    <p class="tw-mb-1">
      {{ $t('You need to setup one of the following options:') }}
    </p>
    <ol class="tw-mb-4">
      <li>{{ $t('A limited company (PSC)') }}</li>
      <li>{{ $t('A sole trader business') }}</li>
      <li>{{ $t('Use an Umbrella service') }}</li>
    </ol>
  </div>
</template>

<script setup>
import { useTranslation } from '@/composables/translation'

const { $t } = useTranslation()
</script>
